import "./Design.scss";
import profile from "../assets/warehouseSideShotMedRes.webp";
import hands from "../assets/wristsMedRes.webp";
import brakes from "../assets/brakesLowRes.webp"
import tools from "../assets/toolsLowRes.webp"
import probe from "../assets/warehouseProbeMedRes.webp"
import toolkit from "../assets/toolkitLowRes.webp"
import { useRef, useEffect, useState } from 'react';
import DashedLine from "../components/DashedLine";
// import PulsingChevrons from "../components/PulsingChevrons";
import SlotMachineRotator from '../components/SlotMachineRotator';


function Design() {
//fade out

const landingRef = useRef(null);
  const nextSectionRef = useRef(null);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (landingRef.current && nextSectionRef.current) {
        const nextSectionRect = nextSectionRef.current.getBoundingClientRect();
        const viewportHeight = window.innerHeight;

        // Calculate when the top of the next section reaches 50% of the viewport height
        const triggerPoint = viewportHeight * 0.6;

        // Calculate the scroll progress of the next section entering the viewport
        if (nextSectionRect.top <= triggerPoint) {
          const progress = Math.min(1, Math.max(0, (triggerPoint - nextSectionRect.top) / (nextSectionRect.height * 0.5))); // Adjust 0.5 for sensitivity
          setScrollProgress(progress);
        } else {
          setScrollProgress(0);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Calculate opacity (fading out as scrollProgress increases)
  const landingOpacity = Math.max(0, 1 - scrollProgress * 2);

  // Calculate blur (increasing as scrollProgress increases)
  const blurAmount = Math.min(1, scrollProgress * 5) * 15;


  // fade in
  const missionRef = useRef(null);
  const [isAtTop, setIsAtTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (missionRef.current) {
        const rect = missionRef.current.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const fadeOutStartThreshold = viewportHeight * 0.50; // 20% of viewport height

        // Check if the top of the div has scrolled past the point where the fade should start
        setIsAtTop(rect.top <= fadeOutStartThreshold);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <div className="width">
      <div 
      className="designMain"
      >

        <div 
        //  ref={missionRef}
         className="introTextSection"
         >
        <DashedLine coords={[[90, 33],[90, 100]]} />
    <div className="introTextContainer">
          <div className="introText">
            we are building
            </div>
            <div className="introText">
           robots for
            </div>
             <div className="introText">
            <SlotMachineRotator
          words={["craftsmen", "technicians", "artisans", "engineers", "experts", "tradesmen", "operators", "builders"]}
          className="introText2" // Optional: for styling
          style={{ fontWeight: 'bold' }} // Optional: for styling
          scrollSensitivity={6}
        />
          </div>
          </div>
        </div>


        <div
          ref={missionRef}
      className={`transitionImage ${isAtTop ? 'at-top' : ''}`}
         >
          <img src={profile} className="designImage" alt="side view of the threehalves robot, highlighting the centaur form factor"></img>
          <div className="imageText">
            centaur chassis
          </div>
          <DashedLine coords={[[90, 0],[90, 100]]} />
          {/* <PulsingChevrons x={88} y={10} vertical={true} color="white" size={200} /> */}

        </div>
        <div className="designInfo">
        {/* <DashedLine coords={[[90, 0],[90,15]]} />
        <DashedLine coords={[[28, 15],[90,15]]} /> */}
        <DashedLine coords={[[28,100],[28, 15],[90,15],[90, 0]]} />
          <div  className="designInfoSquare">
        <img src={brakes}  className="designInfoImage" alt="a close up of the air brakes on the leg of the threehalves robot"></img>
        </div>
          <span className="textBlock">
            Humanlike torso and arms allow for natural teleoperation and interfacing with
            designed-for-human tools and environments. Quadruped body with
            friction braked joints allows for a stable platform with no latent
            power consumption when not in motion, and increased stability and
            failsafes over a biped in both normal operation and in the event of
            loss of motor control.{" "}
          </span>
        </div>
        <div className="designImageContainer">
        <DashedLine coords={[[28,0],[28, 27]]} />
        <DashedLine coords={[[28,65],[28, 100]]} />
          <div className="imageText2">
            no hands
          </div>
          <img src={hands} className="designImage" alt="a closeup of the quick disconnect interface on the wrist of the threehalves robot"></img>
        </div>
        <div className="designInfo2">
        <DashedLine coords={[[28,0],[28, 10],[70,10],[70,90],[28,90],[28,100]]} />

        <div  className="designInfoSquare">
        <img src={tools}  className="designInfoImage" alt="a chainsaw and impact gun retrofitted to quickly connect to the wrist of the threehalves robot"></img>
        </div>
          <div className="textBlock">
            Quick connect wrist interface provides uncompromised tool
            positioning accuracy and repeatability. 12v, 18v, and 48v power, as
            well as air, can be provided to attachments from the robot side.{" "}
          </div>
        </div>
        <div className="designImageContainer">
        <DashedLine coords={[[28,0],[28, 30]]} />
        <div className="imageText2">
            resilient precision
          </div>
          <img src={probe} className="designImage" alt="the threehalves robot using a touch probe to measure position of the robot's head"></img>
        </div>
        <div 
        // className="designInfo"
        ref={landingRef}
        className="designInfoEnd"
        style={{
          opacity: landingOpacity,
          filter: `blur(${blurAmount}px)`,
        }}
        >
          <DashedLine coords={[[28,0],[28, 55]]} />
          <div className="designInfoSquare">
          <img src={toolkit}  className="designInfoImage" alt="the simple toolkit needed to replace limbs on the threehalves robot"></img>
          </div>
          <div className="textBlock">
            All limbs, torso, and head can be replaced and recalibrated in minutes if damaged, and share 3 common fasteners for the entirety of their serviceable assemblies. Bring certain precision to uncertain environments.
          </div>
        </div>
      </div>
        <div ref={nextSectionRef} className="next-section">
      </div>
    </div>
  );
}

export default Design;
